// helper
import Util from "@/helper/Utility.js";
import { BlobConfigDataModal } from "./BlobConfigDataModal.js";

export function BlobConfigDataBuilder() {
    this.blobConfigDataModal = new BlobConfigDataModal();

    this.create = function () {
        return this.blobConfigDataModal;
    }

    this.setLocale = function (localCode) {
        this.blobConfigDataModal.lblCode = localCode ? localCode : 1033;
        return this;
    }

    this.setWithBlob = function (dict,blobURL,lblCode, blobConfig) {
        this.setBlob(dict);
        this.setBlobUrl(blobURL);
        this.setLocale(lblCode);
        this.setBlobCustom(blobConfig);

        this.setAppName();
        this.setMainAppName();
        // this.setInputName();
        this.setAppImage();
        // this.setMainAppImage();
        this.setArrowImage();
        this.setCallcenter();

        return this;
    }

    this.setBlob = function(blobConfig) {
        this.blobConfigDataModal.blobConfig = blobConfig ? blobConfig : null;
        return this;
    }
    this.setBlobCustom = function(blobCustomConfig) {
        this.blobConfigDataModal.lineLiffId = blobCustomConfig.liffId ? blobCustomConfig.liffId : null;
        return this;
    }

    this.setBlobUrl = function(blobURL) {
        this.blobConfigDataModal.blobURL = Util.isEmptyStr(blobURL) ? null :blobURL;
        return this;
    }

    this.setAppName = function() {
        this.blobConfigDataModal.appName = this.blobConfigDataModal.lblCode == 1033 ? this.blobConfigDataModal.blobConfig.from_name_point_en : this.blobConfigDataModal.blobConfig.from_name_point_th;
        return this;
    }

    this.setMainAppName = function() {
        this.blobConfigDataModal.mainAppName = this.blobConfigDataModal.lblCode == 1033 ? this.blobConfigDataModal.blobConfig.to_name_point_en : this.blobConfigDataModal.blobConfig.to_name_point_th;
        return this;
    }

    this.setInputName = function() {
        this.blobConfigDataModal.inputName = this.blobConfigDataModal.lblCode == 1033 ? this.blobConfigDataModal.blobConfig.input.input_name_en : this.blobConfigDataModal.blobConfig.input.input_name_th;
        return this;
    }

    this.setAppImage = function() {
        this.blobConfigDataModal.appImgUrl =  `${this.blobConfigDataModal.blobURL}/image/${this.blobConfigDataModal.blobConfig.file_name}`;
        return this;
    }
    this.setCallcenter = function() {
        this.blobConfigDataModal.callcenter =  this.blobConfigDataModal.blobConfig.callcenter;
        return this;
    }

    this.setMainAppImage = function() {
        this.blobConfigDataModal.mainAppImgUrl =  `${this.blobConfigDataModal.blobURL}/image/logo-app-main.png`;
        if (this.blobConfigDataModal.blobConfig.logo_app_file_name) {
            this.blobConfigDataModal.mainAppImgUrl =  `${this.blobConfigDataModal.blobURL}/image/${this.blobConfigDataModal.blobConfig.logo_app_file_name}`;
        }

        return this;
    }

    this.setArrowImage = function() {
        this.blobConfigDataModal.arrowUrl =  `${this.blobConfigDataModal.blobURL}/image/arrow.png`;
        if (this.blobConfigDataModal.blobConfig.arrow_file_name) {
            this.blobConfigDataModal.arrowUrl =  `${this.blobConfigDataModal.blobURL}/image/${this.blobConfigDataModal.blobConfig.arrow_file_name}`;
        }

        return this;
    }
}
